import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { IOtpLoginRequest } from '~/@api/generated-api-types-user/Api'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

function useUserOtpLoginMutation() {
  const client = useApiClientUser()
  const {
    mutate: userOtpLoginMutation,
    isPending: isRequestingUserOtpLogin,
    error: userOtpLoginError,
  } = useMutation({
    mutationFn: async (props: IOtpLoginRequest) => {
      return client.user
        .userOtpControllerOtpLogin(props)
        .then(({ data }) => data)
    },
  })

  return {
    userOtpLogin: userOtpLoginMutation,
    isRequestingUserOtpLogin,
    error: getApiErrorMessage(userOtpLoginError, 'Prihlásenie sa nepodarilo.'),
  }
}

export { useUserOtpLoginMutation }
